import { IconProps } from "./Icons";

export const IconMic = ({
  width = 16,
  height = 23,
  color = "#0B3E5F",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15.5C9.19309 15.4988 10.337 15.0243 11.1806 14.1806C12.0243 13.337 12.4988 12.1931 12.5 11V5C12.5 3.80653 12.0259 2.66193 11.182 1.81802C10.3381 0.974106 9.19347 0.5 8 0.5C6.80653 0.5 5.66193 0.974106 4.81802 1.81802C3.97411 2.66193 3.5 3.80653 3.5 5V11C3.50124 12.1931 3.97575 13.337 4.81939 14.1806C5.66303 15.0243 6.80691 15.4988 8 15.5ZM5 5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2C8.79565 2 9.55871 2.31607 10.1213 2.87868C10.6839 3.44129 11 4.20435 11 5V11C11 11.7956 10.6839 12.5587 10.1213 13.1213C9.55871 13.6839 8.79565 14 8 14C7.20435 14 6.44129 13.6839 5.87868 13.1213C5.31607 12.5587 5 11.7956 5 11V5ZM8.75 18.4625V21.5C8.75 21.6989 8.67098 21.8897 8.53033 22.0303C8.38968 22.171 8.19891 22.25 8 22.25C7.80109 22.25 7.61032 22.171 7.46967 22.0303C7.32902 21.8897 7.25 21.6989 7.25 21.5V18.4625C5.40091 18.2743 3.68728 17.4072 2.44048 16.0288C1.19368 14.6504 0.502284 12.8586 0.5 11C0.5 10.8011 0.579018 10.6103 0.71967 10.4697C0.860322 10.329 1.05109 10.25 1.25 10.25C1.44891 10.25 1.63968 10.329 1.78033 10.4697C1.92098 10.6103 2 10.8011 2 11C2 12.5913 2.63214 14.1174 3.75736 15.2426C4.88258 16.3679 6.4087 17 8 17C9.5913 17 11.1174 16.3679 12.2426 15.2426C13.3679 14.1174 14 12.5913 14 11C14 10.8011 14.079 10.6103 14.2197 10.4697C14.3603 10.329 14.5511 10.25 14.75 10.25C14.9489 10.25 15.1397 10.329 15.2803 10.4697C15.421 10.6103 15.5 10.8011 15.5 11C15.4977 12.8586 14.8063 14.6504 13.5595 16.0288C12.3127 17.4072 10.5991 18.2743 8.75 18.4625Z"
        fill={color}
      />
    </svg>
  );
};
